class StorageEngine {
  constructor() {
    this.set = this.set.bind(this);
    this.get = this.get.bind(this);
    this.remove = this.remove.bind(this);
  }

  set(key, value) {
  }

  get(key) {
  }

  remove(key) {
  }
}

export {StorageEngine};
